// Add your EmailJS credentials here
export const EMAILJS_SERVICE_ID = "service_rqorsq5";
export const EMAILJS_TEMPLATE_ID = "template_7vk3yq7";
export const EMAILJS_USER_ID = "nYg_-5gBbAtQbYPWr";
